import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-[7px] cursor-pointer whitespace-nowrap rounded-[8px] text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-3.5 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-gray-800 text-white border border-gray-700 hover:bg-gray-700",
        primary:
          "bg-brand-600 text-white border border-brand-700 hover:bg-brand-700",
        destructive:
          "bg-red-600 text-white border border-red-700 hover:bg-red-700",
        success:
          "bg-green-600 text-white border border-green-700 hover:bg-green-700",
        outline:
          "border border-border-secondary bg-bg-primary text-text-primary hover:bg-bg-hover",
        secondary:
          "bg-bg-tertiary text-text-primary border border-border-primary hover:bg-border-primary",
        "secondary-disabled":
          "bg-gray-200 text-gray-500 border border-gray-300 cursor-not-allowed",
        ghost: "hover:bg-bg-tertiary text-text-secondary",
        link: "text-brand-600 underline-offset-4 hover:[&>span]:underline",
      },
      size: {
        default: "h-[33px] px-[11.5px] py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-10 px-6",
        icon: "h-[33px] w-[35px] p-0",
        "icon-sm": "h-8 w-8 p-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
